module.exports = __webpack_public_path__ + "media/otter_icons/symbol-defs-1f9975b4.svg";